import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useInterval from "@use-it/interval";
import { Avatar, Select, Tooltip } from "antd";
import { User, PowerButton, Location } from "assets/icons/index";
import { readConfigFile } from "utils/appConfig";
import { getUrlKeycloakLogout } from "utils/auth/config";
import { clearLocalStorage, loadKeycloakTokenForNps, loadNotificationFromLocalStorage } from "utils/auth/localStorage";
import TokenService from "utils/auth/Token.service";
import { mapSelectObject, parseLocation } from "utils/functions";
import useTranslation from "utils/hooks/useTranslation";
import Notification from "../notification";
import * as S from "./styled/topBar.styled";

const tokenService = new TokenService();

const TopBar = ({ username, locationId, locationDescription, userSessionUpdateUserData, userSessionUpdateLocationAsync, locationsList }) => {
  const router = useNavigate();

  const getFirstName = (name: string) => name.split(" ")[0];
  const [notificationMessage, setNotificationMessage] = useState([]);
  const [hasNotification, setHasNotification] = useState(false);

  const handleLogoff = async () => {
    const keycloakIdToken = loadKeycloakTokenForNps();

    try {
      const keycloakLogoutUrl = await getUrlKeycloakLogout(keycloakIdToken);
      clearLocalStorage();
      tokenService.deleteToken();
      window.location.replace(keycloakLogoutUrl);
    } catch (error) {
      console.error("Error redirecting to Keycloak logout:", error);
      clearLocalStorage();
      tokenService.deleteToken();
      router("/multiple-realms", { replace: true });
    }
  };

  useEffect(() => {
    const notifyMessage = async () => {
      try {
        const config = await readConfigFile();
        const notifications = config.VITE_YMS_NOTIFICATION || [];
        if (Array.isArray(notifications) && notifications.length > 0) {
          setNotificationMessage(notifications);
          setHasNotification(loadNotificationFromLocalStorage());
        } else {
          setNotificationMessage([]);
          setHasNotification(loadNotificationFromLocalStorage());
        }
      } catch (error) {
        setNotificationMessage([]);
        setHasNotification(loadNotificationFromLocalStorage());
      }
    };
    notifyMessage();
  }, []);

  const MINUTES_TO_VALIDATE_TOKEN = 240000; // 4 minutes

  useInterval(() => {
    const validateToken = async () => {
      try {
        await tokenService.validRefreshToken();
        const userData = await tokenService.refreshDecodeToken();
        userSessionUpdateUserData(userData);
      } catch (error) {
        console.error("Error validating token:", error);
      }
    };

    validateToken();
  }, MINUTES_TO_VALIDATE_TOKEN);

  const onChangeLocation = (location) => {
    const locationSelected = parseLocation(location);
    userSessionUpdateLocationAsync(locationSelected.id);
  };

  return (
    <>
      <S.HeaderFix>
        <S.Logo>
          <img src="/images/logo_Logan.svg" alt="Logan" width={109} height={32} className="image-log" />
        </S.Logo>
        <p></p>
        <S.Perfil>
          <Notification hasNotification={hasNotification} notificationMessage={notificationMessage} />
          <Avatar style={S.Avatar} className="avatarLocation" size={40} icon={<Location style={S.InfoIcon} className="locationIcon" width="24" height="24" />} />
          <Select
            optionFilterProp="children"
            size="large"
            style={{ width: "200px" }}
            defaultValue={{ value: locationId, label: locationDescription }}
            bordered={false}
            onChange={onChangeLocation}
          >
            {locationsList?.length > 0 && mapSelectObject(locationsList)}
          </Select>
          <Avatar style={S.Avatar} size={40} className="avatarUser" icon={<User style={S.InfoIcon} className="userIcon" width="24" height="24" />} />
          <span className="username">{getFirstName(username)}</span>
          <Tooltip placement="bottom" title={useTranslation({ id: "exit" })}>
            <S.ButtonLogout onClick={handleLogoff} type="text">
              <PowerButton width="24" height="24" className="logout" />
            </S.ButtonLogout>
          </Tooltip>
        </S.Perfil>
      </S.HeaderFix>
    </>
  );
};

export default TopBar;
